import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import ImageSlider from "../components/ImageSlider";
import { getProductDetails } from "../redux/actions/productActions";
import Navbar from "../components/Navbar";
import axios from "../api/axiosConfig";

export default function ProductDetails() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const { loading, error, product } = useSelector((state) => state.productDetails);

  useEffect(() => {
    dispatch(getProductDetails(id));
  }, [dispatch, id, refreshTrigger]);

  const handleDeleteFile = async (fileUrl) => {
    if (!window.confirm("Delete this file permanently?")) return;
    try {
      await axios.delete(`/products/${id}/file`, { data: { fileUrl } });
      alert("File deleted!");
      setRefreshTrigger((prev) => prev + 1);
    } catch (err) {
      alert("Error deleting file.");
    }
  };

  const renderImageSrc = (path) => {
    if (!path) return "";
    return path.startsWith("http") ? path : `http://localhost:5000/${path.replace(/\\/g, "/")}`;
  };

  const getFileName = (url) => {
    if (!url) return "File";
    const parts = url.split("/");
    const fullName = parts.pop();
    return fullName.split("_").slice(1).join("_") || fullName;
  };

  if (loading) return <div className="text-center mt-5"><div className="spinner-border text-primary"></div></div>;
  if (error) return <h4 className="text-center text-danger mt-5">{error}</h4>;
  if (!product) return null;

  const sliderImages = [];
  if (product.displayImage) sliderImages.push(renderImageSrc(product.displayImage));

  return (
    <>
      <Navbar />
      <div className="container py-5 animate-fade-in" style={{ maxWidth: "1000px" }}>
        
        {/* HEADER CARD */}
        <div className="card p-4 mb-4 text-center bg-white">
          <h2 className="fw-bold text-primary mb-0">{product.model}</h2>
          <span className="text-muted">{product.partNumber}</span>
        </div>

        <div className="row g-4">
          {/* LEFT: IMAGES */}
          <div className="col-md-5">
            <div className="card p-3 h-100">
              {sliderImages.length > 0 ? (
                <ImageSlider images={sliderImages} />
              ) : (
                <div className="alert alert-light text-center">No images available</div>
              )}
            </div>
          </div>

          {/* RIGHT: SPECS */}
          <div className="col-md-7">
            <div className="card p-4 h-100">
              <h5 className="fw-bold mb-4 border-bottom pb-2 text-primary">Specifications</h5>
              <div className="row g-3">
                {[
                  { label: "Storage", value: product.storage },
                  { label: "Price", value: `₹${product.price}` },
                  { label: "OD", value: product.od },
                  { label: "ID", value: product.id },
                  { label: "Height", value: product.height },
                  { label: "OX", value: product.ox },
                  { label: "NKI", value: product.nki },
                ].map((item, idx) => (
                  <div className="col-6" key={idx}>
                    <div className="p-2 bg-light rounded border-start border-4 border-primary">
                      <small className="text-muted d-block">{item.label}</small>
                      <span className="fw-bold">{item.value || "-"}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* FILE LIST */}
        {product.files?.length > 0 && (
          <div className="card mt-4 p-4">
            <h5 className="fw-bold mb-3 text-primary">Attached Files</h5>
            <div className="list-group">
              {product.files.map((fileUrl, index) => (
                <div className="list-group-item d-flex justify-content-between align-items-center" key={index}>
                  <div className="d-flex align-items-center gap-3">
                    <i className="bi bi-file-earmark-text fs-4 text-secondary"></i>
                    <span className="fw-medium">{getFileName(fileUrl)}</span>
                  </div>
                  <div className="d-flex gap-2">
                    <a href={renderImageSrc(fileUrl)} download target="_blank" rel="noreferrer" className="btn btn-sm btn-outline-primary">
                      <i className="bi bi-download"></i>
                    </a>
                    <button className="btn btn-sm btn-outline-danger" onClick={() => handleDeleteFile(fileUrl)}>
                      <i className="bi bi-trash"></i>
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </>
  );
}